import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { submitProblemReport } from "./thunks/submit-report";

const name = "problemReport";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitProblemReport.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = "";
      })
      .addCase(submitProblemReport.fulfilled, (state) => {
        state.isSubmitting = false;
      })
      .addCase(submitProblemReport.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
